/**
 *
 */
//
export default [
 
  {
    text: 'ID',
    
    value : 'id'
  },
  {
    text: 'visto',
    value : (response)=>{
      return (response.flag_viewed ) ? 'Si' : 'No'
    },
    align: 'center',
        component: {
            type: 'chip-label',
            custom:'flag_viewed_string',
            props: {
                palette: {
                    si: 'success lighten-3',
                    no: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
  },
  {
    text: 'stock Critico generado por ',
    value: (response)=>{
      return (response.flag_notification_from_sale) ? 'VENDEDOR TERRENO' : 'VENTA SALA'
    }
  },
  {
    text: 'Fecha creación',
    sortable: true,
    // value: ('created_at)=>{
    //   return moment(response.created_at).format('DD-MM-YYYY')
    // }
    value:'created_at',
    format:'date',
    
  }
 
]
